export default "__VITE_ASSET__D5x_N_7k__"